import { createAction } from 'typesafe-actions';
import {
  NazgulPredictionResponse,
  Predictions,
} from '../models/predictions.model';
import { PredictionModel } from '../models/prediction-model.model';
import { NazgulPredictionRequest } from '../resources/nazgul-prediction.resource';

enum Types {
  RUN_PREDICTIONS = "[User] We're running predictions for a set of labels given some document text.",
  REQUEST_NAZGUL_PREDICTIONS = "[User] We're requesting predictions from Nazgul 2.0 REST API.",
  NAZGUL_PREDICTIONS_SUCCESS = '[Epic] We got back successful predictions from Nazgul 2.0.',
  FETCH_PREDICTIONS_ERROR = 'FETCH_PREDICTIONS_ERROR',
  APPEND_PREDICTIONS = 'APPEND_PREDICTIONS',
  FETCH_PREDICTION_MODELS = 'FETCH_PREDICTION_MODELS',
  SET_PREDICTION_MODELS = 'SET_PREDICTION_MODELS',
}

export const runPredictions = createAction(
  Types.RUN_PREDICTIONS,
  resolvePayload => (annotationTypes?: string[]) =>
    resolvePayload({ annotationTypes }),
);

export const fetchPredictionsError = createAction(
  Types.FETCH_PREDICTIONS_ERROR,
  resolvePayload => (error: string) => resolvePayload({ error }),
);

export const appendPredictions = createAction(
  Types.APPEND_PREDICTIONS,
  resolvePayload => (predictions: Predictions) => resolvePayload(predictions),
);

export const fetchPredictionModels = createAction(
  Types.FETCH_PREDICTION_MODELS,
);

export const setPredictionModels = createAction(
  Types.SET_PREDICTION_MODELS,
  resolvePayload => (models: PredictionModel[]) => resolvePayload(models),
);

export const requestNazgulPredictions = createAction(
  Types.REQUEST_NAZGUL_PREDICTIONS,
  resolvePayload => (request: NazgulPredictionRequest) =>
    resolvePayload(request),
);

export const nazgulPredictionsSuccess = createAction(
  Types.NAZGUL_PREDICTIONS_SUCCESS,
  resolvePayload => (response: NazgulPredictionResponse) =>
    resolvePayload(response),
);
